import React from 'react'
import classNames from 'classnames'
import 'project/polyfill'
import { NextPageWithLayout } from '../types/nextPageWithLayout'
import SeoContainer, {
  SeoContainerProps,
} from 'components/util/containers/SeoContainer'
import { homeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import PoweredByHero from 'components/hero/PoweredByHero'
import Strings from 'project/localisation'
import HeadingAndText from 'components/HeadingAndText'
import { mailroomStrings } from 'common/strings/mailroom-strings'
import DivertYourPostCard from 'components/cards/DivertYourPostCard'
import StopWastingTimeCard from 'components/cards/StopWastingTimeCard'
import SearchPostCard from 'components/cards/SearchPostCard'
import MailroomSetupCard from 'components/cards/MailroomSetupCard'
import MailroomFeaturesSection from 'components/sections/MailroomFeaturesSection'
import { ItemListElements } from 'next-seo/lib/types'
import ReviewsTrustCard from 'components/cards/ReviewsTrustCard'
import PoweredByLogo from 'components/hero/PoweredByLogo'
import useWindowSize from 'components/util/useWindowSize'
import imageResize from 'project/image-proxy-web'

export type HomePageType = {}
const HomePage: NextPageWithLayout<HomePageType> = () => {
  const seoProps: SeoContainerProps['seoProps'] = {
    description: mailroomStrings.seoMailroomDescription,
    openGraph: {
      url: 'https://www.hoxtonmix.com/mailroom/',
    },
    title: mailroomStrings.seoMailroomTitle,
  }

  const mailroomBreadcrumb: ItemListElements[] = [
    homeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/mailroom/',
      name: `${Strings.mailroom}`,
      position: 2,
    },
  ]
  const size = useWindowSize()
  const logoA = require('public/images/logos/mailroom-logo-white.svg')
  const logoB = require('public/images/hero/mailroom-hero.png')
  return (
    <SeoContainer breadcrumb={mailroomBreadcrumb} seoProps={seoProps}>
      <main className='overflow-hidden container-legacy'>
        <PoweredByHero className={'hero--mailroom'} background={'red'}>
          <div className='d-flex text-center align-items-center justify-content-center flex-column'>
            <img
              fetchPriority='high'
              loading='eager'
              className='img-fluid hero-brand--mailroom mt-lg-3 mt-6'
              alt={`${Strings.mailroom} ${Strings.logo}`}
              src={imageResize(logoA)}
            />

            <div className={'d-flex flex-lg-column flex-column-reverse'}>
              <img
                fetchPriority='high'
                loading='eager'
                className='img-fluid hero__image hero__image--mailroom mt-xxxl-n4 mt-lg-0 mt-n3'
                alt={`${Strings.mailroom} ${Strings.logo}`}
                src={imageResize(logoB)}
              />

              <PoweredByLogo
                width={size.isLgOrHigher ? 122 : 111}
                height={size.isLgOrHigher ? 36 : 20}
                fill={'black'}
                fill2={size.isLgOrHigher ? '#fff' : '#FDDD1C'}
                className='mt-xxxl-n18 mt-xl-n12 mt-lg-n8 mt-1'
              />
            </div>
          </div>
        </PoweredByHero>
        <div className={'container mw-auto'}>
          <HeadingAndText
            className={'mt-xxxl-50 mt-xxl-50 mt-lg-18 mt-8'}
            headingSize={1}
            title={mailroomStrings.mailroomTitle}
            classesForTitle={classNames(
              'mb-lg-3 mb-2 pxl-lg-0 px-12',
              size.isLgOrHigher ? 'text-bold' : 'text-semibold',
            )}
            subtitle={mailroomStrings.mailroomSubtitle}
            classesForSubTitle={'mx-sm-0 mx-n1'}
          />
          <DivertYourPostCard />
          <StopWastingTimeCard />
          <div className='row px-xs-0 px-2'>
            <SearchPostCard />
            <ReviewsTrustCard
              color={size.isLgOrHigher ? 'red2' : 'gradient-red'}
            />
          </div>
          <MailroomSetupCard />
          <h3
            dangerouslySetInnerHTML={{ __html: mailroomStrings.whyMailroom }}
            className='h2 text-center text-semibold mt-lg-34 mt-14 mb-lg-0 mb-12'
          />
          <MailroomFeaturesSection />
        </div>
        <div className='spacer' />
      </main>
    </SeoContainer>
  )
}

export default HomePage
